import { messages as portuguese } from './pt-BR'
import { messages as english } from './en'
import { messages as spanish } from './es'

const messages = {
  'pt-BR': portuguese,
  en: english,
  es: spanish
}

export { messages }
